import PropTypes from 'prop-types';

const propType = {
  thumb: PropTypes.string.isRequired,
};

export default { propType };
